module.exports = __webpack_public_path__ + "img/book-open.f1ea97a.svg";